import default_logo_image from '../src/assets/AA_Round.png'
import userAvatar from '../src/assets/userAvi.svg'
import notificationPing from '../src/assets/notification.mp3'

export const dataset_defaults = {
    timeout: 8000,
    max_bot_response_delay_ms: 1000,
    chat_origin: '',
    initial_payload: null,
    chat_persistence: 'false',
    read_more_cut_off: 10000,
    notification_sound: notificationPing,
    style_endpoint: null,
    tenant_id: '00000000-00000000-00000000-00000000',

    // widget starter toggle setup
    external_control: 'false',
    external_open: 'false',

    // Logos
    big_bot_avatar_url: default_logo_image,
    mini_bot_avatar_url: default_logo_image,
    user_avatar_url: userAvatar,
    header_logo: default_logo_image,
    default_sponsor_logo: null,
    default_sponsor_header_logo: null,
    default_sponsor_menu_logo: null,
    default_sponsor_cover_page_text: '',
    sponsored_content: [],

    // Styling
    font: 'Verdana',
    title: 'AccessAva',
    height: '331px', // represents the height of the main section, the full widget height has + 60px x2 for header & input
    width: '370px',
    avatar_bg_color: 'white',
    header_bg_color: '#9305F2',
    header_text_color: 'white',
    header_button_bg_color: '#d1d1d1',
    header_button_text_color: '#ffffff',
    chat_bg_color: '#F9F6F2',
    user_bg_color: '#00588C',
    user_text_color: 'white',
    bot_bg_color: 'white',
    bot_text_color: 'black',
    bot_hyperlink_color: '#9305F2',
    scrollbar_thumb_color: '#808080',
    scrollbar_track_color: 'darkgrey',
    read_more_bg_color: '#f28705',
    read_more_text_color: '#9305F2',
    buttons_bg_color: '#9305F2',
    buttons_text_color: 'white',
    send_icon_color: 'black',
    quick_replies_bg_color: 'orange',
    quick_replies_text_color: 'black',

    // coverpage styles
    cover_page_hyperlink_color: '#00588c',
    cover_page_start_btn_color: '#9305F2',
    cover_page_start_btn_text_color: 'white',
    cover_page_background_color: '#F9F6F2',
    cover_page_text_color: 'black',
    cover_page_dropdown_bg_color: 'grey',
    cover_page_dropdown_text_color: 'white',

    // Feature toggles and attributes
    use_menu: 'true',
    page_layout: 'false',
    open_links_new_tab: 'true',
    remote_config_url: null,
    terms_link: '', // if blank, the page doesn't reload, it just doesn't link anywhere
    privacy_link: '', // as above
    //powered_by_link: 'https://accesscharity.org.uk/',
    // below are example menu items
    // menu_items: [
    //     { title: 'Safeguarding', contentful_id: '4mXcij81ujRLNkVc0EwzrZ ' },
    //     { title: 'Moving House', contentful_id: 'someid' },
    //     { title: 'Post-Hospital Care', contentful_id: 'someid' },
    //     { title: 'Home Care', contentful_id: 'someid' },
    //     { title: 'Funding', contentful_id: 'someid' },
    //     { title: 'Another Example', contentful_id: 'someid' },
    // ],

    // Inactive popup toggles
    use_inactive_popup: 'true',
    inactive_popup_text: 'Find out more about your social care rights',
    inactive_popup_border_color: '#9305F2',
    inactive_popup_bg_color: 'white',
    inactive_popup_text_color: 'black',
    inactive_popup_close_color: 'black',

    // For Email transcript option in menu
    transcript_intent: '/transcript',
    transcript_slot: 'email',

    // For checking endpoints
    health_check: 'false',
    health_check_endpoints: null,
    hide_on_health_check_fail: 'true',

    widget_default_open: 'false',
    find_out_more_url: '',
}
